
const displaydetailsatd = (state = [], action) => {
    switch (action.type) {
      case 'TOGGLE_VISIBLE_DT':
      return {
          type: "TOGGLE_VISIBLE_DT",
          displaydetailsatd: action.displaydetailsatd
        }
      default:
        return state
    }
  }
  
  export default displaydetailsatd
  